import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Stack, Typography, createTheme, useMediaQuery } from '@mui/material';
import './style.css';
import { datetimeFormatter } from '../../utils/datetimeFormatter';
import dayjs from 'dayjs';
import { isEmpty } from '../../utils/helper';

export const ReadOnlyAdditionalServiceRequired = observer(({ details }) => {
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const getData = (value) => {
    return isEmpty(value) ? '_' : value;
  };

  return (
    <Paper sx={{ px: '30px', py: '20px', pb: '40px' }}>
      <Stack spacing={4}>
        <Stack spacing={3}>
          <Grid rowGap={2} container justifyContent={'space-evenly'}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Documents To Be Applied
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Construction Approval
                  </Typography>
                  {details?.borewellMotor ? (
                    <>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Borewell Motor Vendor Name
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Borewell Motor Agency Name
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Borewell Motor Contact Name
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Borewell Motor Executed Date
                      </Typography>
                    </>
                  ) : (
                    ''
                  )}
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.documentsToBeApplied)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.constructionApproval)}
                  </Typography>
                  {details?.borewellMotor ? (
                    <>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {getData(details?.borewellMotorVendorName)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {getData(details?.borewellMotorAgencyName)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {getData(details?.borewellMotorContactName)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {details?.borewellMotorExecutedDate
                          ? datetimeFormatter.formatDate(details?.borewellMotorExecutedDate, datetimeFormatter.toLocal)
                          : '_'}
                      </Typography>
                    </>
                  ) : (
                    ''
                  )}
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  {details?.marking ? (
                    <>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Marking Vendor Name
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Marking Agency Name
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Marking Contact Name
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Marking Executed Date
                      </Typography>
                    </>
                  ) : (
                    ''
                  )}
                  {details?.executionAndCasing ? (
                    <>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Execution And Casing Vendor Name
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Execution And Casing Agency Name
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Execution And Casing Contact Name
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'end',
                        }}
                        component="p"
                      >
                        Execution And Casing Executed Date
                      </Typography>
                    </>
                  ) : (
                    ''
                  )}
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  {details?.marking ? (
                    <>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {getData(details?.markingVendorName)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {getData(details?.markingAgencyName)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {getData(details?.markingContactName)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {details?.markingExecutedDate
                          ? datetimeFormatter.formatDate(details?.markingExecutedDate, datetimeFormatter.toLocal)
                          : '_'}
                      </Typography>
                    </>
                  ) : (
                    ''
                  )}
                  {details?.executionAndCasing ? (
                    <>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {getData(details?.executionAndCasingVendorName)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {getData(details?.executionAndCasingAgencyName)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {getData(details?.executionAndCasingContactName)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: '700',
                          alignSelf: 'start',
                        }}
                        component="p"
                      >
                        {details?.executionAndCasingExecutedDate
                          ? datetimeFormatter.formatDate(
                              details?.executionAndCasingExecutedDate,
                              datetimeFormatter.toLocal
                            )
                          : '_'}
                      </Typography>
                    </>
                  ) : (
                    ''
                  )}
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </Paper>
  );
});
